module.exports = __webpack_public_path__ + "static/img/gaozhonghuaxue3.377340af.jpg";